import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["addNewButtonHandler", "addNewButtonText", "isAddNewButtonDisabled", "shouldRenderAddNewButton", "permissionsRequiredForAddingData"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { PermissionsConsumer } from '../../../../widgets/permissionsHelper';
import Button from '../../../../atoms/Button';
import Content from '../../../../atoms/Content';
import styles from './withAddNewButtonAtBottom.module.scss';
export default function withAddNewButtonAtBottom(TableComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(withAddNewButtonAtBottomComponent, _React$PureComponent);
    var _super = _createSuper(withAddNewButtonAtBottomComponent);
    function withAddNewButtonAtBottomComponent() {
      var _this;
      _classCallCheck(this, withAddNewButtonAtBottomComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "renderEmptyPlaceHolder", function () {
        var emptyPlaceHolderText = _this.props.emptyPlaceHolderText;
        return /*#__PURE__*/React.createElement(Content, {
          className: styles.emptyPlaceHolder
        }, emptyPlaceHolderText);
      });
      return _this;
    }
    _createClass(withAddNewButtonAtBottomComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          addNewButtonHandler = _this$props.addNewButtonHandler,
          addNewButtonText = _this$props.addNewButtonText,
          isAddNewButtonDisabled = _this$props.isAddNewButtonDisabled,
          shouldRenderAddNewButton = _this$props.shouldRenderAddNewButton,
          permissionsRequiredForAddingData = _this$props.permissionsRequiredForAddingData,
          tableProps = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/React.createElement("div", {
          className: cx(styles.addNewButtonAtBottomTable)
        }, /*#__PURE__*/React.createElement(TableComponent, _extends({
          minRows: 0,
          EmptyPlaceholder: this.renderEmptyPlaceHolder
        }, tableProps)), shouldRenderAddNewButton && /*#__PURE__*/React.createElement(PermissionsConsumer, {
          validFor: permissionsRequiredForAddingData
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.addNewButtonWrapper
        }, /*#__PURE__*/React.createElement(Button, {
          view: Button.VIEW.TERTIARY,
          disabled: isAddNewButtonDisabled,
          className: styles.addNewButton,
          onClick: addNewButtonHandler
        }, addNewButtonText))));
      }
    }]);
    return withAddNewButtonAtBottomComponent;
  }(React.PureComponent), _defineProperty(_class, "propTypes", {
    addNewButtonText: PropTypes.string,
    addNewButtonHandler: PropTypes.func,
    shouldRenderAddNewButton: PropTypes.bool,
    isAddNewButtonDisabled: PropTypes.bool,
    emptyPlaceHolderText: PropTypes.string,
    permissionsRequiredForAddingData: PropTypes.arrayOf(PropTypes.string)
  }), _defineProperty(_class, "defaultProps", {
    addNewButtonText: __('Add New'),
    permissionsRequiredForAddingData: EMPTY_ARRAY,
    emptyPlaceHolderText: __('Start adding data by clicking the below button'),
    addNewButtonHandler: _noop,
    shouldRenderAddNewButton: true,
    isAddNewButtonDisabled: false
  }), _class;
}